import { useAtomValue } from 'jotai';
import { userACRoles } from '~/stores/UserStore';
import { AC_TLGeo_Role } from '~/common/typescript/services/access_control/AC_Tlgeo';

/**
 * Hook to check if current user is TLGEO_ADMIN
 * Only TLGEO_ADMIN can see "Ảnh của tôi" menu
 */
export const useIsTLGeoManager = (): boolean => {
  const roles = useAtomValue(userACRoles);
  return roles.includes(AC_TLGeo_Role.TLGEO_ADMIN);
};
